<ng-template [projector]="projectorName.PageData">
  <div class="page-title">
    <button
      *ngIf="!hideBackBtn"
      class="back-btn"
      mat-icon-button
      [attr.test-id]="'back-to-previous-page-btn'"
      (click)="
        backBtnPath
          ? routerFacade.go({
              path: [backBtnPath],
              queryParams: backBtnQueryParams
            })
          : routerFacade.back()
      "
    >
      <ui-svg-icon [name]="iconNameList.BackLeft" class="tw-ml-2"></ui-svg-icon>
    </button>
    <h1 class="title" cropText>
      {{ title }} <span *ngIf="subtitle" class="subtitle">{{ subtitle }}</span>
    </h1>
    <div *ngIf="labelText" [matTooltip]="tooltipText" class="status-label {{ labelColor | lowercase }}">
      {{ labelText }}
    </div>
    <ng-content select="[title]"></ng-content>
  </div>
</ng-template>

<div class="tw-flex tw-justify-between tw-items-center tw-gap-x-8">
  <nav *ngIf="displayedMenuItems$ | async" class="sub-nav tw-shrink" mat-tab-nav-bar [tabPanel]="panel">
    <a
      *ngFor="let item of displayedMenuItems$ | async"
      #rla="routerLinkActive"
      [routerLink]="item.url"
      [queryParamsHandling]="preserveQueryParams ? 'preserve' : ''"
      [active]="rla.isActive"
      [attr.test-id]="item.title.split('.').slice(-1)"
      mat-tab-link
      routerLinkActive
    >
      {{ item.title | translate }}
    </a>
  </nav>

  <projection-slot [name]="projectorName.NavbarActions"></projection-slot>
</div>

<div class="tw-flex tw-gap-x-8 page-toolbar">
  <ng-content select="[toolbar]"></ng-content>
</div>

<div class="page-body" [ngClass]="{ 'tw-mt-0': noIndents }">
  <mat-tab-nav-panel #panel>
    <ng-content select="[body]"></ng-content>
  </mat-tab-nav-panel>
</div>
